module.exports = __webpack_public_path__ + "static/media/login-page-logo.dd458330.png";